import React, { useState, useEffect, Fragment } from "react";

import "./PageHeader.scss";
import hamburger from "../../assets/menunew.png";
import close from "../../assets/icons-icon-close@2x.png";
import ibaalogo from "../../assets/IBAA_Tour_Logo_Black_CMYK.webp";

import { withRouter } from "react-router-dom";

import { oneDispatchAction } from "../../providers/action";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LanguageSelector from "../../library/baaShared/LanguageSelector/index";
import { updateBookingDetailsbyKey } from "../../redux/bookingDetailsActions";

import * as Actions from "../../redux/appActions";

import dictionary from "i18next";

class PageHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      className: "",
      collapse: false,
      isTop: "",
      Open: false,
      mobileMode: false,
      isMenuOpen: false,
      showLanguage: false,
      dropdownopen: false,
      defaultLanguage: "",
      dropdownOpen: false,
      selectedLang: "",
      matches: window.matchMedia("(min-width: 992px)").matches,
      isBookingPage: false,
      isBookingLandingPage: false,
    };
  }
  componentDidMount() {

    // Permanent redirect for /contact/privacy-notice to DHE privacy policy page.
    const targetUrlEN = "/en/contact/privacy-notice"; // The URL to check for
    const targetUrlAR = "/ar/contact/privacy-notice"; // The URL to check for
    if (window.location.pathname === targetUrlEN) {
      // Redirect immediately to the new URL
      window.location.href = "https://privacy.dubaiholding.com/en/privacy-notice/customers---dubai-holding-entertainment-llc";
    }
    if (window.location.pathname === targetUrlAR) {
      // Redirect immediately to the new URL
      window.location.href = "https://privacy.dubaiholding.com/ar/privacy-notice/customers---dubai-holding-entertainment-llc";
    }

    // console.log(this.props.location.pathname.substring(3, 24), "this.props.location")
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia("(min-width: 992px)").addListener(handler);

      if (this.props.location.pathname.includes("tour-booking")) {
            this.setState({ isBookingPage: true });
      }


    //single place of validation for any jumeirah guest on pageheader component
    if (
      sessionStorage.getItem("guestType") &&
      sessionStorage.getItem("guestType") === "Jumeirah"
    ) {
      //if value already exists is sessionStorage
      updateBookingDetailsbyKey({ isJumeirahGuest: true });
    } else {
      //if value already does not exist check if current link has it
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      let guestType = params.get("guest");
      if (guestType === "Jumeirah") {
        sessionStorage.setItem("guestType", guestType);
        this.props.updateBookingDetailsbyKey({ isJumeirahGuest: true });
      } else {
        //if both are false then we can revert to original prices
        this.props.updateBookingDetailsbyKey({ isJumeirahGuest: false });
      }
    }
    let currentLang = document.documentElement.lang;
    switch (currentLang) {
      case "en":
        currentLang = "English";
        this.setState({ defaultLanguage: currentLang });
        break;
      case "ar":
        currentLang = "Arabic";
        this.setState({ defaultLanguage: currentLang });
        break;
      case "ru":
        currentLang = "Russian";
        this.setState({ defaultLanguage: currentLang });
        break;
    }
    if (
      !this.state.Open &&
      typeof document !== "undefined" &&
      document.body &&
      document.body.style &&
      document.body.style.hasOwnProperty("position")
    ) {
      var body = document.body;
      body.classList.remove("site-position");
      // document.body.style.removeProperty("position")
      // document.body.style.removeProperty("overflow")
      document.body.style.overflowX = "hidden";
    }
    let isFromImportantInfo = sessionStorage.getItem("fromImportantInfo");
    if (!isFromImportantInfo) {
      window.scrollTo(0, 0);
    }
    if (this.props.location.pathname === "en/booking/retrieve-booking") {
      window.scrollTo(0, 0);
    }
  }

  toggle = () => {
    this.refs.child.toggle();
    this.setState({ collapse: !this.state.collapse });
  };

  handleScroll = () => {
    //Scrollng fixed for flickring before >0 it was.
    if (window.pageYOffset > 100) {
      if (!this.state.className) {
        this.setState({
          className: "blue",
          isTop: "0px",
        });
      }
    } else {
      if (this.state.className) {
        this.setState({
          className: "",
          isTop: "",
        });
      }
    }
  };

  isOpen = () => {
    this.setState(
      (prevState) => {
        return {
          Open: !prevState.Open,
        };
      },
      () => {
        if (this.state.Open === true) {
          var body = document.body;
          body.classList.add("site-position");
          // document.body.style.position = "fixed";
          // document.body.style.overflow = "hidden";
          if (document.getElementById("booking-overview-hide") !== null) {
            document.getElementById("booking-overview-hide").style.display =
              "none";
          }
          if (document.getElementById("booking-stepper-hide") !== null) {
            document.getElementById("booking-stepper-hide").style.display =
              "none";
          }
        } else {
          var body = document.body;
          body.classList.remove("site-position");
          // document.body.style.removeProperty("position")
          // document.body.style.removeProperty("overflow")
          document.body.style.overflowX = "hidden";
          if (document.getElementById("booking-overview-hide") !== null) {
            document.getElementById("booking-overview-hide").style.display =
              "block";
          }
          if (document.getElementById("booking-stepper-hide") !== null) {
            document.getElementById("booking-stepper-hide").style.display =
              "block";
          }
        }
      }
    );
  };

  handleClick = (linkItem) => {
    if (
      linkItem["Link Title"].value ===
      dictionary.t("Home-ImpInfo", "Important Info")
    ) {
      sessionStorage.setItem("fromImportantInfo", true);
    }  else {
      sessionStorage.removeItem("fromImportantInfo");
    }
    if (linkItem["Link Title"].value === "WHAT'S ON" || linkItem["Link Title"].value === "Tickets" || linkItem["Link Title"].value === " Partners & Events") {
    
   } else {
     this.props.history.push(linkItem.Hyperlink.value.href);
   }
  };
  handleBookClick = () => {
    // localStorage.removeItem("addon_selected")

    let pagetype = this.props.pageData && this.props.pageData.templateId;
    this.props.oneDispatchAction(Actions.PAGE_TYPE_CONTEXT, pagetype);
    this.props.oneDispatchAction(
      Actions.PATH_CONTEXT,
      window.location.pathname
      );

    this.props.oneDispatchAction(Actions.PAGE_CTA_CONTEXT, "TOP RIGHT CTA");

    let bookLink =
      this.props &&
      this.props.fields &&
      this.props.fields["Book Now CTA"] &&
      this.props.fields["Book Now CTA"].value && 
      this.props.fields["Book Now CTA"].value.href;

      this.props.history.push(bookLink);

     //window.location.assign(bookLink);

    window.location.reload();
  };

  handleTicketsNavigation = (urlParam) => {
    this.isOpen();
    window.location.hash = urlParam;
    window.location.pathname = `${window.location.pathname.substring(
      1,
      3
    )}/tours-details`;
  };

  getClass = (link) => {
    let classTest = "";
    if (link.fields.Hyperlink.value.href === this.props.location.pathname) {
      if (
        link.fields["Link Title"].value ===
          dictionary.t("Home-ImpInfo", "Important Info") ||
        link.fields["Link Title"].value ===
          dictionary.t("ExperienceCollection-Visit", "Visit")
      ) {
        if (
          link.fields["Link Title"].value ===
            dictionary.t("Home-ImpInfo", "Important Info") &&
          sessionStorage.getItem("fromImportantInfo")
        ) {
          classTest = "active";
        } else if (
          link.fields["Link Title"].value ===
            dictionary.t("ExperienceCollection-Visit", "Visit") &&
          !sessionStorage.getItem("fromImportantInfo")
        ) {
          classTest = "active";
        }
      } else {
        classTest = "active";
      }
    }
    return classTest;
  };

  render() {
    // console.log(window.location.pathname.substring(0, 3), "header")
    let defaultLang = "";
    let currentLang = this.props.pageData.itemLanguage;
    switch (currentLang) {
      case "en":
        currentLang = "English";
        defaultLang = currentLang;
        break;
      case "ar":
        currentLang = "Arabic";
        defaultLang = currentLang;
        break;
      case "ru":
        currentLang = "Russian";
        defaultLang = currentLang;
        break;
    }

    let socialIcons = this.props && this.props.fields["Header Social Links"];
    let myBookingLink =
      this.props &&
      this.props.fields &&
      this.props.fields["My Booking CTA"] &&
      this.props.fields["My Booking CTA"].value &&
      this.props.fields["My Booking CTA"].value.href;
    let myBookingText =
      this.props &&
      this.props.fields &&
      this.props.fields["My Booking CTA Text"] &&
          this.props.fields["My Booking CTA Text"].value;

    let titleArray =
      this.props &&
      this.props.fields &&
      this.props.fields["Primary Navigation Links"] &&
      this.props.fields["Primary Navigation Links"].length > 0 &&
      this.props.fields["Primary Navigation Links"];


    return (
        <header
          ref={(r) => (this.ref = r)}
          // className={this.state.className}
          className={
            !window.location.pathname.includes("tour-booking/")
              ? this.state.className
              : "logo-tour"
          }
        >
          <div className="row">
                  {/* {!window.location.pathname.includes("tour-booking")&& */}
                  {
                      titleArray && (
                          <div
                              className={
                                  !window.location.pathname.includes("tour-booking/")
                                      ? "col-1 d-lg-none hamburger-new"
                                      : "col-1 d-lg-none hamburger-new hamburger-visibleHide"
                              }
                          >
                              <img
                                  src={this.state.Open ? close : hamburger}
                                  onClick={this.isOpen}
                              />
                          </div>
                          )
                  }
            {/* } */}
            <div className="col-9 col-lg-2 new-logo hamburger-new-logod">
              {/* <a onClick={() => this.props.history.push(logoLink)}> */}
              {
                  titleArray ? (
                  <img
                      src={ibaalogo}
                      alt="logo"
                      className="png-logo"
                      onClick={() => {
                          window.location = window.location.pathname.substring(0, 3);
                      }}
                  />
              ) : (

                      <img
                          src={ibaalogo}
                          alt="logo"
                          className="png-logo"
                      />
                  )
              }
              {/* <BrandIcon className="svg-logo" /> */}
              {/* </a> */}
            </div>
            <div
              className={`col-lg-9 ${
                this.state.Open ? "only-mobile" : "hide-component"
              }`}
            >
            <div className="row only-mobile-hamberger">
                  {
                      titleArray && (
                          <div className="col-1 d-lg-none hamburger-new">
                              <img
                                  alt="menu"
                                  src={this.state.Open ? close : hamburger}
                                  onClick={this.isOpen}
                              />
                          </div>)
                  }
                <div className="col-9 col-lg-2 new-logo hamburger-new-logod">
                  {/* <a onClick={() => {this.props.history.push(logoLink);
            this.state.Open && this.isOpen() }}> */}
                  {
                      titleArray ? (
                              <img
                                  src={`${ibaalogo}`}
                                  alt="logo"
                                  className="png-logo"
                                  onClick={() => {
                                      window.location = window.location.pathname.substring(0, 3);
                                      this.state.Open && this.isOpen();
                                  }}
                              />
                        ) :
                        (
                              <img
                                  src={`${ibaalogo}`}
                                  alt="logo"
                                  className="png-logo"     
                              />
                      )
                  }
                  
                  {/* <BrandIcon className="svg-logo" /> */}
                  {/* </a> */}
                </div>
                <div className="col-2 col-lg-1">
                  {
                  this.state.isBookingPage === false && (
                    <p
                      className="button12"
                      onClick={() => {
                        this.handleBookClick();
                        this.state.Open && this.isOpen();
                      }}
                    >
                      {dictionary.t("Booking-Book", "Book")}
                    </p>
                  )}
                </div>
              </div>
              <div className="link-wrapper-new">
                <div className="primary-navigation">
                {!this.state.Open && titleArray && (
                    <div className="language">
                      <LanguageSelector
                        currentLanguage={defaultLang}
                        showLanguage={this.state.showLanguage}
                        languageSelectorData={this.props.fields["Language"]}
                        languageAvailable={this.props.languageAvailable}
                      />
                    </div>
                  )}                                
                  {
                        titleArray && titleArray.map((link, index) => (
                              <div className={"new-link"} onClick={() => { }}>
                                  <p
                                      onClick={() => {
                                          this.handleClick(link.fields);
                                          this.state.Open && this.isOpen();
                                      }}
                                      className={"tickets-dd-wrap"}
                                  >
                                      {link.fields["Link Title"].value}
                                </p>
                                {
                                    link.fields["Secondary Navigation"] && link.fields["Secondary Navigation"].length > 0 && (
                                        <div className={"tickets-dropdown"}>
                                            {
                                                link.fields["Secondary Navigation"].map((secondlink, secondindex) => (
                                                    <p
                                                        onClick={() => {
                                                            this.handleClick(secondlink.fields);
                                                            this.state.Open && this.isOpen();
                                                        }}
                                                        className={`new-link ${this.getClass(link)}`}
                                                    >
                                                        { secondlink.fields["Link Title"].value}
                                                    </p>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                              </div>                       
                      ))
                  }
                </div>
                <div className="mobile-links">
                  <p
                    onClick={() => this.props.history.push(myBookingLink)}
                    className={`new-link ${
                      myBookingLink === this.props.location.pathname
                        ? "active"
                        : ""
                    }`}
                  >
                    {myBookingText.trim()}
                  </p>
                  <div className="language-selector">
                    <LanguageSelector
                      currentLanguage={defaultLang}
                      showLanguage={this.state.showLanguage}
                      languageSelectorData={this.props.fields["Language"]}
                      languageAvailable={this.props.languageAvailable}
                    />
                  </div>
                </div>
                {!this.state.matches && (
                  <div className="icons">
                    {socialIcons.map((listSocialIcon, index) => {
                      let image =
                        listSocialIcon.fields &&
                        listSocialIcon.fields["Social Icon"].value
                          ? listSocialIcon.fields["Social Icon"].value
                          : "";
                      let src = image && image.src ? image.src : "";
                      let alt = image && image.alt ? image.alt : "";
                      let link =
                        listSocialIcon.fields &&
                        listSocialIcon.fields.Hyperlink &&
                        listSocialIcon.fields.Hyperlink.value &&
                        listSocialIcon.fields.Hyperlink.value.url
                          ? listSocialIcon.fields.Hyperlink.value.url
                          : "";

                      return (
                        <a href={link} className="icon-list">
                        <img className="SocialIcons" alt={alt} src={src}></img>
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
                  </div>
                  {
                      titleArray && (
                          <div
                              className="col-2 col-lg-1"
                              style={
                                  this.state.Open
                                      ? { display: "none" }
                                      : { display: "flex", alignItems: "center" }
                              }
                          >
                              {this.state.isBookingPage === false && (
                                  <div
                                      className="button11"
                                      onClick={() => {
                                          this.handleBookClick();
                                          this.state.Open && this.isOpen();
                                      }}
                                  >
                                      {dictionary.t("Booking-Book", "Book")}
                                  </div>
                              )}
                          </div>
                      )
                  }
          </div>
          {/* <h1 id="seo-heading">
            {(this.props.location.pathname.split("/").slice(-1)[0]==="en" || this.props.location.pathname.split("/").slice(-1)[0]==="ar" ) ?
          "Home" :
            this.props.location.pathname.split("/").slice(-1)[0]}</h1> */}
        </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    page_type_context: state.appDetails.page_type_context,
    page_cta_context: state.appDetails.page_cta_context,
    path_context: state.appDetails.path_context,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      oneDispatchAction: oneDispatchAction,
      updateBookingDetailsbyKey,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PageHeader));
